<template>
    <form @submit.prevent="submit">
        <div class="mb-3">
            <label
                for="agency"
                class="form-label"
                >Agency:</label
            >
            <SelectField
                id="agency"
                v-model="selectedOri"
                :select-items="agencies"
                :is-horizontal="false"
                :is-required="true">
            </SelectField>
        </div>
        <div class="mb-3">
            <label
                for="year"
                class="form-label"
                >Year:</label
            >
            <SelectField
                id="year"
                v-model="year"
                :select-items="years"
                :is-horizontal="false"
                :is-required="true">
            </SelectField>
        </div>
        <div class="mb-3">
            <label
                for="stop-number"
                class="form-label"
                >Stop Number:</label
            >
            <input
                v-model="stopNumber"
                type="text"
                class="form-control" />
        </div>
        <div class="text-end">
            <b-button
                type="submit"
                :loading="loading"
                :disabled="!canSubmit">
                Submit
            </b-button>
        </div>
    </form>
    <confirm-modal></confirm-modal>
</template>
<script lang="ts" setup>
import SelectField from "../Misc/SelectField.vue";
import {ConfirmModal} from "../Misc/";
import {BButton} from "../BButton";
import {useCommunityPolicingStore} from "@/stores/communityPolicingStore";
import {storeToRefs} from "pinia";
import {ref, watch, computed, onMounted} from "vue";
import {SelectItem} from "@/types";
import {handleError} from "@/stores/storeHelper";
import {useConfirmDialog} from "@/composable/useConfirmDialog";
const communityPolicingStore = useCommunityPolicingStore();
const {stopNumberOris: agencies} = storeToRefs(communityPolicingStore);
const selectedOri = ref("");
const year = ref(0);
const years = ref([] as SelectItem[]);
const stopNumber = ref("");
const loading = ref<boolean>(false);
const canSubmit = computed(() => {
    return year.value && stopNumber.value && selectedOri.value != null;
});

watch(
    () => selectedOri.value,
    async (val: any) => {
        if (selectedOri.value) {
            years.value = [] as SelectItem[];
            let availableYears = await communityPolicingStore.getGetAvailableStopNumberYears(selectedOri.value);

            years.value = availableYears.map((x) => ({label: `${x}`, value: x} as SelectItem));
            year.value = 0;
        }
    }
);

const {confirm} = useConfirmDialog();

const submit = async () => {
    const shouldProceed = await confirm("Delete Confirmation", "Are you sure you want to delete this stop?");

    if (shouldProceed) {
        communityPolicingStore.validateStopInfo(stopNumber.value, selectedOri.value, year.value).then((result) => {
            if (result && result.data) {
                communityPolicingStore
                    .submitDelete(stopNumber.value, selectedOri.value, year.value)
                    .then((response) => {
                        window.location.href = "dataupload.aspx?source=6";
                    })
                    .catch(function (error) {
                        handleError(error);
                    });
            } else {
                handleError(
                    "The record couldn't be located using the information that was provided. Please verify your information and try the request again."
                );
            }
        });
    }
};
onMounted(async () => {
    await communityPolicingStore.getStopNumberOris();
});
</script>
